// extracted by mini-css-extract-plugin
export default {"fale":"Contatos_fale__RzMXL","estruturatitulo":"Contatos_estruturatitulo__39mpT","estruturadesc":"Contatos_estruturadesc__-1R4P"};